// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__vKdSB","disabled":"FileBtn_disabled__1ZMuh","warn":"FileBtn_warn__3FnGU","fade":"FileBtn_fade__2iQXT"};